'use strict';
import React, { PureComponent } from 'react';
import ImportarModelosBuscador from './ImportarModelosBuscador';


class ImportarModelosContables extends PureComponent {
    constructor(props) {
        super(props);
    
        this.limpiarBusqueda = this.limpiarBusqueda.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.buscarModelos = this.buscarModelos.bind(this);
        this.mostrarResultados = this.mostrarResultados.bind(this);
        this.cancelarBusqueda = this.cancelarBusqueda.bind(this);
        this.importarModelo = this.importarModelo.bind(this);
    }

    mostrarResultados() {
        this.props.mostrarOcultarResultadosImportarModelos(true);
    }

    buscarModelos(event) {
        let valorInput = event.target.value;

        this.props.buscarModelosImportar(valorInput);
    }

    limpiarBusqueda() {
        this.props.buscarModelosImportar("");
    }

    cancelarBusqueda() {
        this.props.buscarModelosImportar("");
        this.props.mostrarOcultarResultadosImportarModelos(false);
        this.props.mostrarOcultarImportarModelos(false);
    }

    importarModelo(codigoModelo) {
        this.props.buscarModelosImportar("");
        this.props.mostrarOcultarResultadosImportarModelos(false);
        this.props.mostrarOcultarImportarModelos(false);
        this.props.importarModelo(codigoModelo);
    }

    onKeyPress(event) {
        let regExp = /[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ \s]/ig;

        if (!regExp.test(event.key)) {
            event.preventDefault();
        }
    }

    render() {
        const {
            descripcionModeloSeleccionadoImportar,
            inputImportarModelo,
            modelosFiltradosImportarModelo,
            modeloSeleccionadoImportar,
            mostrarResultadosImportarModelo
        } = this.props;

        //ACTIONS
        const { 
            buscarModelosImportar
        } = this.props;

        let arrayModelos = [];


        modelosFiltradosImportarModelo && modelosFiltradosImportarModelo.map(modelo => {
            arrayModelos.push(<ImportarModelosBuscador
                                    buscarModelosImportar={buscarModelosImportar}
                                    key={modelo.Codigo}
                                    modelo={modelo}
                            />);
        });

        arrayModelos = arrayModelos.length == 0 ? 
                                <div className="ABMModelos__opcionBuscadorCuentasContablesSinResultados">No se encontraron resultados</div>
                            : 
                                arrayModelos;

        return (
            <div className="ABMModelosModalContainer__contenedorBuscadorReemplazarCuentas ABMModelos__contenedorBuscadorReemplazarCuentas AsientosContables--floatRight">
                <div>
                    <div className="col-md-12 seccionSuperior__buscador ABMModelosModalContainer__buscadorMargen AsientosContables--floatNone ABMModelos__contenedorBuscadorImportarModelos">
                        {!modeloSeleccionadoImportar ? 
                            <div className="AsientosContables--floatLeft seccionSuperior__iconoLupa ABMModelosModalContainer__iconoLupaInput"></div>
                        :
                            null
                        }

                        <div className="AsientosContables--floatLeft">
                            <input
                                className={"textbox-rectangular form-control default-input top-separator-xxxs bottom-separator-xxs seccionSuperior__inputBuscador ABMModelosModalContainer__buscadorAncho" + (modeloSeleccionadoImportar ? " ABMModelos__buscadorCuentasContables--valorSeleccionado" : "")}
                                id={"buscadorImportarModelos"}
                                disabled={Boolean(modeloSeleccionadoImportar)}
                                name={"buscadorImportarModelos"}
                                onChange={modeloSeleccionadoImportar ? null : this.buscarModelos}
                                onClick={modeloSeleccionadoImportar ? null : this.mostrarResultados}
                                onKeyDown={null}
                                onKeyPress={modeloSeleccionadoImportar ? null : this.onKeyPress}
                                placeholder="Buscar modelos"
                                value={modeloSeleccionadoImportar ? descripcionModeloSeleccionadoImportar : inputImportarModelo}
                            />
                        </div>


                        {(inputImportarModelo && inputImportarModelo.length > 0) || modeloSeleccionadoImportar ?
                            <div className="seccionSuperior__botonBuscador ABMModelosModalContainer__buscadorBotonBorrarBusqueda ABMModelos__contenedorBuscadorImportarModelos__botonLimpiar">
                                <button type="button" className="btn-tag seccionSuperior__botonBorrarBusqueda"
                                    onClick={this.limpiarBusqueda}>
                                    <span className="ti-close span-closable" />
                                </button>
                            </div>
                        :
                            null
                        }
                    </div>

                    <div className={"ABMModelos__contenedorBuscadorImportarModelosBotones AsientosContables--overflowHidden slider-tarjetas" + (mostrarResultadosImportarModelo ? "" : " closed")}>
                        <div className={"modalLogIntentosScroll ABMModelos__ContenedorOpcionesBuscadorImportarModelos"}>
                            {arrayModelos}
                        </div>

                        <div className="ABMModelos__contenedorBotonesImportarModelos">
                            <div className="AsientosContables--floatLeft">
                                <button className={"seccionCabecera__botonAceptar" + (modeloSeleccionadoImportar ? "" : " ABMModelosModalContainer__botonAceptar--deshabilitado")} onClick={() => modeloSeleccionadoImportar ? this.importarModelo(modeloSeleccionadoImportar) : null} >
                                    Importar
                                </button>
                            </div>

                            <div className="seccionCabecera__contenedorBotones--float">
                                <button className="seccionCabecera__botonCancelar" onClick={this.cancelarBusqueda} >
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ImportarModelosContables;